import { useMemo } from 'react';
import useHubSpotDefinedEventProperties from 'flow-doctor-lib/hooks/useHubSpotDefinedEventProperties';
import { getObjectTypeIdFromObject } from 'flow-doctor-lib/utils/eventFilterUtils';
export const useEventProperties = ({
  event
}) => {
  const eventTypeId = getObjectTypeIdFromObject(event.eventTypeId);
  const {
    data,
    loading,
    error
  } = useHubSpotDefinedEventProperties({
    portalId: event.portalId,
    objectTypeId: eventTypeId
  });
  const filteredEventProperties = useMemo(() => {
    if (data) {
      return Object.entries(event.properties).reduce((acc, [property, propertyValue]) => {
        const maybePropertyDef = data[property];
        if (maybePropertyDef && !maybePropertyDef.property.hidden) {
          return Object.assign({}, acc, {
            [property]: propertyValue
          });
        }

        // By default, hide unknown fields
        return acc;
      }, {});
    }
    return event.properties;
  }, [data, event.properties]);
  return {
    eventProperties: data,
    eventPropertiesLoading: loading,
    eventPropertiesError: error,
    filteredEventProperties
  };
};